import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import errorCodes from '@/constants/errors';
import { states } from '@/constants/lifecycle';
import NotAuthorised from '@/components/errors/NotAuthorised';
import {
  fetchCollectionDatasets,
  showAddCollectionDatasets,
  toggleCollectionDatasetSelected,
} from '../actions';
import { collectionPermissions } from '../../sharing/constants';
import { collectionPerms } from '../../sharing/state/state';

const CollectionDatasetsPanelContainer = ({
  canRead,
  children,
  className,
  readErrors,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-collection-datasets-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: {
    role: {
      permissions: {
        datasets, collections, cohorts, requests,
      },
    },
  },
  collectionDatasets: { collectionDatasets },
  themes: { theme },
}, { category, code }) => {
  const item = findResult(collectionDatasets, category, code);
  const collectionMemberPermissions = item?.permissions || collectionPerms();

  return {
    canRead: datasets.read,
    canManage: collections.datasets || collectionMemberPermissions[collectionPermissions.DATASETS],
    allowMultiSelect: collections.datasets
        || collectionMemberPermissions[collectionPermissions.DATASETS],
    allowStatus: requests.create || cohorts.create,
    datasets: item?.results || [],
    filterTerm: item?.filter || '',
    readStatus: item?.readStatus || states.NONE,
    readErrors: item?.readErrors || [],
    total: item?.count || 0,
    currentPage: item?.currentPage || null,
    pageSize: item?.pageSize || null,
    pageCount: item?.totalPages || null,
    theme,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchCollectionDatasets,
  onCheckBoxClick: toggleCollectionDatasetSelected,
  showAddDataset: showAddCollectionDatasets,
};

export default CollectionDatasetsPanelContainer;
